import { render, staticRenderFns } from "./config-custom-torznab.vue?vue&type=template&id=2a24e1e0&scoped=true"
import script from "./config-custom-torznab.vue?vue&type=script&lang=js"
export * from "./config-custom-torznab.vue?vue&type=script&lang=js"
import style0 from "./config-custom-torznab.vue?vue&type=style&index=0&id=2a24e1e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a24e1e0",
  null
  
)

export default component.exports